import React, {useState} from 'react';
import "./RiddleCard.css";

const RiddleCard = ({allSolved, mainInfo, title, overwriteString, index, layout = "half-size", displayFlexColumn = false, center = false, connected = true}) => {
    const [isHidden = false, setIsHidden] = useState(false);

    const toggleHide = () => {
        setIsHidden(!isHidden); // Toggle the state between hidden and visible
    };

    const getIcon = (state) => {
        return <div className={`status-dot ${state ? 'active' : 'inactive'}`}>
            {state && <span className="checkmark">✓</span>}
        </div>
    };

    return (
        <div className={`relative-container ${layout}`}>
            {!connected && (
                <div className="disconnected-overlay">Disconnected</div>
            )}
            <div className={`puzzle-card-container ${layout} ${connected ? '' : 'disconnected'}`}>
                <div className="puzzle-title-container">
                    <div className="title-with-status">
                        {(allSolved !== undefined && allSolved !== null) && getIcon(allSolved)}
                        <h3 className="puzzle-card-title">{title}:</h3>
                    </div>
                    <div className="buttons">
                        {overwriteString && (
                            <button className="riddle-btn riddle-btn--danger" onClick={() => {
                                if (window.confirm("Are you sure you want to mark this as solved?")) {
                                    overwriteString(null, index);
                                }
                            }}>
                                <img src={process.env.PUBLIC_URL + '/menu.svg'} alt="toggle" />
                            </button>
                        )}
                        <button className="riddle-btn" onClick={() => toggleHide()}>
                            <img src={process.env.PUBLIC_URL + (isHidden ? '/plus.svg' : '/minus.svg')} alt="toggle" />
                        </button>
                    </div>
                </div>
                <div className={`puzzle-hide-div ${isHidden ? 'hidden' : 'visible'}`}>
                    <div className={`display-container ${displayFlexColumn ? 'column' : ''} ${center ? 'center' : ''}`}>
                        {mainInfo}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RiddleCard;